module.exports = __webpack_public_path__ + "img/党旗btn.e453226c.png";